<template>
    <b-container fluid>
        <b-form-row v-if="!showAnnouncements && !fromDashboard">
            <b-col>There are no announcements to view.</b-col>
        </b-form-row>
        <b-alert v-if="showAnnouncements && fromDashboard"
                 show
                 fade
                 dismissible
                 variant="primary"
        >
            <b-container fluid>
                <b-form-row>
                    <b-col>
                        <b-list-group flush>
                            <b-list-group-item
                                v-for="(announcement, index) in announcementList"
                                :key="index"
                                :variant="(announcement.variant)"
                                outline-variant="primary"
                            >
                                <!-- @click="navigateToAnnouncement(announcement.announcement_id)"
                                button -->
                                <b-form-row class="text-left">
                                    <b-col>
                                        {{ announcement.message_text }}
                                    </b-col>
                                </b-form-row>
                                <b-form-row class="text-right">
                                    <b-col>
                                        <strong>Author: </strong>
                                        {{ announcement.author_name }} (ADMIN)
                                    </b-col>
                                </b-form-row>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-form-row>
            </b-container>
        </b-alert>
        <b-container v-else-if="showAnnouncements" class=" mt-2">
            <b-form-row>
                <b-col class=" mb-2">
                    <span class="text-muted">
                        Click on an entry below to edit that announcement.
                    </span>
                </b-col>
            </b-form-row>
            <b-list-group flush>
                <b-list-group-item
                    v-for="(announcement, index) in announcementList"
                    :key="index"
                    :variant="(announcement.variant)"
                    :class="variantOutline(announcement.variant)"
                    button
                    @click="navigateToAnnouncement(announcement.announcement_id)"
                >
                    <b-form-row class="text-left">
                        <b-col>
                            <strong>ID: </strong>
                            {{ announcement.announcement_id }}
                        </b-col>
                        <b-col>
                            <strong>Author: </strong>
                            {{ announcement.author_name }}
                        </b-col>
                        <!--
                        <b-col>
                            <strong>Status: </strong>
                            <b-badge :variant="announcement.variant">
                                {{ announcement.active ? '' : 'IN' }}ACTIVE
                            </b-badge>
                        </b-col>
                        -->
                    </b-form-row>
                    <b-form-row class="text-left">
                        <b-col>
                            <strong>Text: </strong>
                            <span>
                                {{ announcement.message_text }}
                            </span>
                        </b-col>
                    </b-form-row>
                </b-list-group-item>
            </b-list-group>
        </b-container>
    </b-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'AnnouncementList',

    metaInfo() {
        return { title: 'AnnouncementList' };
    },

    props: { selectable: { type: Boolean, default: true } },

    data() {
        return {
            // announcementList: this.getAnnouncementList,
            user: null,
            displayToggle: { type: Boolean, default: true }
        };
    },

    computed: {
        ...mapGetters({
            isAuthorized: 'auth/isAuthorized',
            authUser: 'auth/authUser',
            isAdmin: 'auth/isAdmin',
        }),

        ...mapState('announcement', {
            announcementList: 'announcementList',
        }),

        fromDashboard() {
            return (this.$route.fullPath === '/dashboard');
        },

        showAnnouncements() {
            return (this.announcementList.length > 0);
        },
    },

    async created() {
        await this.$store.dispatch('announcement/fetchFilteredAnnouncementList', 'active');
    },

    methods: {
        async navigateToAnnouncement(announcementId) {
            let route = { name: 'admin.announcements.AnnouncementUpdate', params: { announcementId } };

            this.$router.push(route);
        },

        getUser() {
            return this.authUser;
        },

        variantOutline(variant) {
            return 'border: solid ' + variant;
        },

        toggle() {
            this.displayToggle = !this.displayToggle;
            return this.displayToggle;
        },
    },
};
</script>

<style lang="scss">
@import '$StyleVars';

.collapsed > .when-open {
  display: none;
}

.when-closed {
    display: none;
}
</style>
